﻿const PatternFill = require('highcharts/modules/pattern-fill');

(PatternFill.default || PatternFill)(Highcharts);

window.initMainTabs = function() {
    //Calculate all tabs width.
    var totalWidth = $("nav.in_right ul").width();
    var tabsWidth = 0;
    var tabs = $("nav.in_right li");
    $.each(tabs, function (index, tab) {
        tabsWidth += $(tab).width();
    });
    var remainderWidth = totalWidth - tabsWidth;
    var addWidth = remainderWidth / tabs.length;

    //Resize tab width and align.
    $.each(tabs, function (index, tab) {
        var adjustedWidth = $(tab).width() + addWidth;

        //Remove 1 px to account for shift from borders
        if (index === tabs.length - 1) {
            adjustedWidth--;
        }

        $(tab).css("width", adjustedWidth + "px");
        $(tab).children("a")
            .css("width", adjustedWidth + "px")
            .css("text-align", "center");
    });
}

window.initWidgetTabs = function() {
    $(".wi_tabs .tabNavigation a").click(function () {
        var parent = $(this).closest(".wi_tabs");
        parent.find(".tabNavigation a").removeClass("selected");
        parent.find(".wi_tabs_table").hide();

        $(this).addClass("selected");
        var pos = $(this).attr("pos");
        parent.find(".wi_tabs_table.pos" + pos).show();

        return false;
    });

    $(".trading-info .tabNavigation a").each(function () {
        if($(this).attr("currentIso") !== undefined && $(this).attr("currentIso") === $(this).attr("exchangeIso")) {
            $(this).click();
        }
    });

    $(".tabNavigation a[pos=1]").not(".trading-info .tabNavigation a").click();
}

window.initNewRow = function() {
    $(".wiNewRow").closest(".PBItem").addClass("clear");
    //if ($.browser.msie && $.browser.version <= 7) //this was deprecated from jquery 1.9
    if (navigator.userAgent.match(/msie/i) || navigator.userAgent.match(/trident/i) && (document.all && !document.querySelector))
    {
        var mas = $(".wiNewRow").closest(".PBItem");
        $.each(mas, function (index, value) {
            var prev1 = $(value).prev();
            var prev2 = prev1.prev();
            if (prev1.length === 1 && prev2.length === 1) {
                var prev2H;
                var prev2MasDiv = prev2.find("div");
                $.each(prev2MasDiv, function (i, val) {
                    if ($(val).height() > 0) {
                        prev2H = $(val).height();
                        return false;
                    }
                });

                var prev1MasDiv = prev1.find("div");
                $.each(prev1MasDiv, function (i, val) {
                    var curH = $(val).height();
                    if (curH > 0) {
                        if (curH < prev2H) { $(val).height(prev2H); }
                        return false;
                    }
                });

                prev1.addClass("AddedHeight_ie7");
            }
        });
    }
}

function initFundPricesWidget() {
    /* limit this to only prices dropdown */
    $(".prices .jqTransformSelectWrapper ul li a").click(function () {
        var index = $(this).attr("index");
        var options = $(this).closest(".jqTransformSelectWrapper").find("select.jqTransformHidden option");
        var url = $(options[index]).attr("value");
        if (url !== "0") {
            open(url, "displayWindow", "width=700,height=500,left=200,top=150,status=no,toolbar=no,menubar=no");
        }
    });
}
window.initPremiumDiscountChart = function() {
    $(".premium_discount_chart").each(function (i, val) {
        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);


        var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                type: 'line',
                width: 710,
                height: 350
            },
            colors: ['#88AB2E'],
            title: {
                text: $('.hidden_data_feilds').find('.hdnChartTitleClass').val()
            },
            xAxis: {
                lineColor: '#88AB2E',
                labels: {
                    type: 'datetime',
                    format: '{value: %b-%Y}',
                    enabled: true,
                    style: {
                        fontSize: '11px'
                    },
                    gridLineWidth: 0
                },
                title: {
                    text: $('.hidden_data_feilds').find('.hdnXaxisTitleClass').val()
                }
            },
            yAxis: {
                title: {
                    text: $('.hidden_data_feilds').find('.hdnYaxisTitleClass').val()
                },
                accessibility: {
                    description: 'trends in premiums and discounts for ' + $('.hidden_data_feilds').find('.hdnNameClass').val() + '. A negative number indicates that the funds shares sold at a discount to NAV; a positive number indicates the shares sold at a premium'
                },
                lineColor: '#88AB2E',
                lineWidth: 1,
                labels: {
                    overflow: 'justify'
                }
            },
            tooltip: {
                formatter: function () {
                    return '' +
                        this.series.name + ' : ' + Highcharts.dateFormat('%b %e %Y', this.x) + '<br />' + this.y + $('.hidden_data_feilds').find('.hdnDaysTitleClass').val();
                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -5,
                y: 20,
                floating: true,
                borderWidth: 1,
                backgroundColor: '#FFFFFF',
                shadow: true
            },
            credits: {
                enabled: false
            },
            exporting: false,
            series: [{
                name: $('.hidden_data_feilds').find('.hdnNameClass').val().toUpperCase(),
                data: eval($('.hidden_data_feilds').find('.hdnSeriesDataClass').val())
            }]
        });
    });
}
function htmlUnescape(value) {
    return String(value)
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&#167;/g, '§');
}

window.initCalenderReturnsChart = function() {
    $(".charttablenav").each(function (i, val) {
        var html = val.ownerDocument.all;
        var descriptionData = "";
        if (html.item("calenderChart-title") != null) {
            var titleElement = html.item("calenderChart-title");
            var tickerElement = html.item("calenderChart-ticker");
            var titleName = titleElement.innerText;
            titleName = "Bar Chart illustrating past performance by " + titleName +". The x - axis represents time and the y - axis represents percent return.";
            if (tickerElement!=null) {
                var tickerName = tickerElement.innerText;
                if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                    titleName = "Bar Chart illustrating past performance of " + tickerName + " ETF by Calendar year. The x - axis represents time and the y - axis represents percent return.";
                    descriptionData = titleName;
                }
                else {
                    descriptionData = titleName;
                }
            }
            else {
                descriptionData = titleName;
            }
        }
        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);

        var chartHiddenFields = $(val.parentElement).find('.chart-hidden-fields');
        var sCategories = eval(chartHiddenFields.find('.hdnCalendarReturnsChartCategories').val());
        var masData = eval(htmlUnescape(chartHiddenFields.find('.hdnCalendarReturnsChartData').val()));
        var nodata = chartHiddenFields.find('.hdnCalendarReturnsChartNoData').val();

        if (nodata !== '') {
            $('#' + uniqueName).html(htmlUnescape(nodata));
        }
        else {
            var chart = new Highcharts.Chart({
                chart: {
                    renderTo: uniqueName,
                    type: 'column',
                    marginLeft: 28,
                    marginBottom: 130,
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: sCategories,
                    lineColor: '#000000',
                    lineWidth: 1
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    lineColor: '#000000',
                    lineWidth: 1
                },
                legend: {
                    useHTML: true,
                    layout: 'vertical',
                    align: 'left',
                    verticalAlign: 'bottom',
                    borderWidth: 0
                },
                tooltip: {
                    formatter: function () {
                        return '' +
                            this.series.name + ': ' + this.y + '';
                    }
                },
                credits: {
                    enabled: false
                },
                accessibility: {
                    description: descriptionData
                },
                series: masData
            });
            chart.legend.group.div.setAttribute('data-ve-gtm', 'chart-legend');
        }
    });
}

window.initPastYearsChart = function() {
    $(".past-years-chart").each(function (i, val) {
        if($(val).is(".initialized")){
            return;
        }

        var html = val.ownerDocument.all;
        var descriptionData = "";
        if (html.item("past-years-chart-title") != null) {
            var titleElement = html.item("past-years-chart-title");
            var tickerElement = html.item("past-years-chart-ticker");
            var titleName = titleElement.innerText;
            titleName = "Bar Chart illustrating past performance by " + titleName +". The x - axis represents time and the y - axis represents percent return.";
            if (tickerElement!=null) {
                var tickerName = tickerElement.innerText;
                if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                    titleName = "Bar Chart illustrating past performance of " + tickerName + " ETF by Calendar year. The x - axis represents time and the y - axis represents percent return.";
                    descriptionData = titleName;
                }
                else {
                    descriptionData = titleName;
                }
            }
            else {
                descriptionData = titleName;
            }
        }
        var uniqueName = "past-years-chart" + i;
        $(val).attr("id", uniqueName);

        var chartHiddenFields = $(val.parentElement).find('.chart-hidden-fields');
        var sCategories = eval(chartHiddenFields.find('.hdnCalendarReturnsChartCategories').val());
        var masData = eval(htmlUnescape(chartHiddenFields.find('.hdnCalendarReturnsChartData').val()));
        var nodata = chartHiddenFields.find('.hdnCalendarReturnsChartNoData').val();
        var moveToZeroXAxis = eval(chartHiddenFields.find('.hdnMoveToZeroXAxis').val());
        var moveToZeroXAxisLabels = eval(chartHiddenFields.find('.hdnMoveToZeroXAxisLabels').val());
        var xAxisWidth = eval(chartHiddenFields.find('.hdnXAxisWidth').val());
        var doNotUsePercentage = !!eval(chartHiddenFields.find('.hdnDoNotUsePercentage').val());

        if (nodata !== '') {
            $('#' + uniqueName).html(htmlUnescape(nodata));
        }
        else {
            var setZeroLineFunc = function() {
                var xx = (-1) * (this.yAxis[0].translate(0, false, false));
                if (moveToZeroXAxis) {
                    this.xAxis[0].axisGroup.translate(0, xx);
                }
                if (moveToZeroXAxisLabels) {
                    this.xAxis[0].labelGroup.translate(0, xx);
                }
            };
            var alterButtonsNotToSendFormFunc = function() {
                $(val).find('button').attr('type', 'button');
            };
            var chart = new Highcharts.Chart({
                chart: {
                    renderTo: uniqueName,
                    type: 'column',
                    marginLeft: 45,
                    marginBottom: 90,
                    events: {
                        redraw: setZeroLineFunc,
                        load: setZeroLineFunc,
                        render: alterButtonsNotToSendFormFunc
                    },
                    height: 250
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: sCategories,
                    lineColor: '#000000',
                    lineWidth: xAxisWidth
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    lineColor: '#000000',
                    lineWidth: 1,
                    labels: {
                        formatter: function() {
                            if (doNotUsePercentage)
                                return this.value;
                            return this.value + '%';
                        }
                    }
                },
                legend: {
                    useHTML: true,
                    layout: 'horizontal',
                    align: 'left',
                    verticalAlign: 'bottom',
                    borderWidth: 0,
                    width: 650
                },
                tooltip: {
                    formatter: function () {
                        if (doNotUsePercentage)
                            return '' +
                                this.series.name + ': ' + this.y;
                        return '' +
                            this.series.name + ': ' + this.y + '%';
                    }
                },
                credits: {
                    enabled: false
                },
                accessibility: {
                    description: descriptionData
                },
                series: masData,
                plotOptions: {
                    column: {
                        minPointLength: 1
                    }
                }
            });
            chart.legend.group.div.setAttribute('data-ve-gtm', 'chart-legend');
            $(val).addClass("initialized");
        }
    });
}

window.initFundvsIndexReturnsChart = function() {
    $(".fundvsindexchart").each(function (i, val) {
        var html = val.ownerDocument.all;
        var descriptionData = "";
        if (html.item("MfPerformance-title") != null) {
            var titleElement = html.item("MfPerformance-title");
            var tickerElement = html.item("MfPerformance-ticker");
            var titleName = titleElement.innerText;
            titleName = titleName.replace(': <br />', ' with')
            titleName = "Bar chart with title " + titleName + " illustrates average maturity";
            if (tickerElement != null) {
                var tickerName = tickerElement.innerText;
                if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                    tickerName = " for the fund " + tickerName;
                    descriptionData = titleName + tickerName;
                }
                else {
                    descriptionData = titleName;
                }
            }
            else {
                descriptionData = titleName;
            }
        }
        var uniqueName = "fundvsindexchart" + i;
        $(val).attr("id", uniqueName);

        var sCategories = eval($('.chart-hidden-fields').find('.hdnFundvsIndexReturnsChartCategories').val());
        var masData = eval($('.chart-hidden-fields').find('.hdnFundvsIndexReturnsChartData').val());
        var nodata = $('.chart-hidden-fields').find('.hdnFundvsIndexReturnsChartNoData').val();

        if (nodata !== '') {
            $('#' + uniqueName).html(htmlUnescape(nodata));
        }
        else {
            var chart = new Highcharts.Chart({
                chart: {
                    renderTo: uniqueName,
                    type: 'column',
                    marginLeft: 45,
                    //width: 700,
                    height: 348,
                    marginBottom: 100
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: sCategories,
                    lineColor: '#000000',
                    lineWidth: 0,
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            fontSize: '8px'
                        }
                    }
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    lineColor: '#000000',
                    lineWidth: 0,
                    labels: {
                        style: {
                            fontSize: '8px'
                        }
                    }
                },
                legend: {
                    enabled: true,
                    align: 'left',
                    verticalAlign: 'bottom',
                    width: 150,
                    itemStyle: {
                        fontSize: '10px'
                    }
                },
                plotOptions: {
                    column: {
                        pointPadding: 0,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            rotation: 270,
                            x: 2,
                            y: -15,
                            formatter: function () {
                                return Highcharts.numberFormat(this.y, 2, '.');
                            },
                            style: {
                                fontSize: '9px',
                                color: 'black',
                                fontWeight: 'bold',
                                textShadow: "0"
                            }
                        }

                    }
                },
                tooltip: {
                    formatter: function () {
                        return '' +
                            this.series.name + ': ' + Highcharts.numberFormat(this.y, 2, '.') + '';
                    },
                    style: {
                        fontSize: '9px'
                    }
                },
                credits: {
                    enabled: false
                },
                accessibility: {
                    description: descriptionData
                },
                series: masData
            });
        }
    });
}
window.initCountryWeightings = function() {
    $(".country_chart_container_pie").each(function (i, val) {
        var uniqueName = "chart" + i;
        $(val).attr("id", uniqueName);
        var decimalSeparator = $(val).data("decimal-separator") || ".";

        var masColor = [];
        var masData = [];
        $(val).parent().find(".bottomRule tr td.leftAlign").each(function (i2, val2) {
            var col1 = $(val2).find(".label").text();
            var col2 = $(val2).find(".value").text().replace(',', '.');
            var flo = parseFloat(col2);
            if (flo >= 0.0) {
                masData.push([col1, flo]);
            }
            masColor.push($(val2).find(".color").text());
        });
        if (masData.length === 0) return;

        Highcharts.setOptions({ colors: masColor });
        var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                backgroundColor: '#FFFFFF',
                plotShadow: false,
                height: 250,
                width: 220,
                align: 'center',
                margin: [0, 0, 0, 0]
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            tooltip: {
                formatter: function () {
                    return '<b>' + this.point.name + '</b> ' + String(this.y).replace(".", decimalSeparator) + ' %';
                },
                style: {
                    fontSize: '9px'
                }
            },
            plotOptions: {
                series: {
                    animation: {
                        complete: function () {
                            $('#' + uniqueName + ' .highcharts-container svg')[0].setAttribute("viewBox", "-5 0 235 250");
                        }
                    }
                },
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    center: [100, 100],
                    dataLabels: {
                        enabled: false,
                        formatter: function () {
                            return '<b>' + this.point.name + '</b> ' + String(this.x).replace(".", decimalSeparator) + ' %';
                        }
                    }
                }
            },
            series: [{ type: 'pie', data: masData }]
        });
    });
}

window.initColumnWithHighchartWidget = function() {
    /*this is intented for PIE charts driven by specific SMARTFORMS to automatically populate a highcharts*/
    $(".chart_container_pie").each(function (i, val) {
        var html = val.ownerDocument.all;

        if (val.classList.contains('js-fund-chart')) {
            return;
        }

        var uniqueName = "chart" + i;
        var descriptionData = "";
        if (html.item("title") != null) {
            var titleElement = html.item("title");
            var titleValue = titleElement.item(i.toString());
            var tickerElement = html.item("ticker");
            var titleName = titleValue.innerText;
            var partTitle = titleName.split(" ");
            var partTitle2 = partTitle[0];
            if (partTitle2 === "Index") {
                partTitle2 = partTitle[1];
            }
            titleName = "Pie chart illustrating the " + titleName + ". Each slice illustrates investment in that " + partTitle2;
            if (tickerElement != null) {
                var tickerValue = tickerElement.item(i.toString());
                var tickerName = tickerValue.innerText;
                if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                    tickerName = " for " + tickerName;
                    descriptionData = titleName + tickerName;
                }
                else {
                    descriptionData = titleName;
                }
            }
            else {
                descriptionData = titleName;
            }
        }
        $(val).attr("id", uniqueName);
        var decimalSeparator = $(val).data("decimal-separator") || ".";

        var masColor = [];
        $(val).parent().find(".details .dia_color").each(function (i2, val2) {
            masColor.push($(val2).css("color"));
        });
        if (masColor.length === 0) return;

        var masData = [];
        $(val).parent().find(".details .data").each(function (i2, val2) {
            var col1 = $(val2).find(".col1").text();
            var col2 = $(val2).find(".col2").text().replace(',', '.');
            var flo = parseFloat(col2);
            if (flo >= 0.0) {
                masData.push([col1, flo]);
            }
        });
        if (masData.length === 0) return;

        Highcharts.setOptions({ colors: masColor });

        var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                backgroundColor: '#FFFFFF',
                plotShadow: false,
                height: 250,
                width: 220,
                align: 'center',
                margin: [0, 0, 0, 0]
            },
            credits: { enabled: false },
            title: { text: '' },
            tooltip: {
                formatter: function () {
                    var pointName = this.point.name;
                    if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                    return '<b>' + pointName + '</b>:' + String(this.y).replace(".", decimalSeparator) + '%';
                }
            },
            accessibility: {
                description: descriptionData
            },
            plotOptions: {
                series: {
                    animation: {
                        complete: function () {
                            $('#' + uniqueName + ' .highcharts-container svg')[0].setAttribute("viewBox", "-5 0 235 250");
                        }
                    }
                },
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    center: [100, 100],
                    dataLabels: {
                        enabled: false,
                        formatter: function () {
                            var pointName = this.point.name;
                            if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                            return '<b>' + pointName + '</b>:' + String(this.y).replace(".", decimalSeparator) + '%';
                        }
                    }
                }
            },
            series: [{ type: 'pie', data: masData }]
        });
    });
}

window.initFundChartWidget = function() {
    /* Chart initialization for new fund widget */
    /* this is intented for PIE charts driven by specific SMARTFORMS to automatically populate a highcharts */
    $(".chart_container_pie.js-fund-chart").each(function (i, val) {
        var uniqueName = "chart" + i;
        var descriptionData = "";
        var parent = val.parentNode;

        var titleElement = parent.getElementsByClassName('js-chart-title')[0];
        if (titleElement != null) {

            var titleName = titleElement.innerText;

            var partTitle = titleName.split(" ");
            var partTitle2 = partTitle[0];
            if (partTitle2 === "Index") {
                partTitle2 = partTitle[1];
            }
            titleName = "Pie chart illustrating the " + titleName + ". Each slice illustrates investment in that " + partTitle2;

            var tickerElement = parent.getElementsByClassName('js-chart-ticker')[0];
            if (tickerElement != null) {
                var tickerName = tickerElement.innerText;
                if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                    tickerName = " for " + tickerName;
                    descriptionData = titleName + tickerName;
                }
                else {
                    descriptionData = titleName;
                }
            }
            else {
                descriptionData = titleName;
            }
        }

        $(val).attr("id", uniqueName);
        var decimalSeparator = $(val).data("decimal-separator") || ".";

        var masColor = [];
        $(parent).find(".details .dia_color").each(function (i2, val2) {
            masColor.push($(val2).css("color"));
        });
        if (masColor.length === 0) return;

        var masData = [];
        $(parent).find(".details .data").each(function (i2, val2) {
            var col1 = $(val2).find(".col1").text();
            var col2 = $(val2).find(".col2").text().replace(',', '.');
            var flo = parseFloat(col2);
            if (flo >= 0.0) {
                masData.push([col1, flo]);
            }
        });
        if (masData.length === 0) return;

        Highcharts.setOptions({ colors: masColor });

        var chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                backgroundColor: '#fff',
                plotShadow: false,
                height: 250,
                width: 220,
                align: 'center',
                margin: [0, 0, 0, 0]
            },
            credits: { enabled: false },
            title: { text: '' },
            tooltip: {
                formatter: function () {
                    var pointName = this.point.name;
                    if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                    return '<b>' + pointName + '</b>:' + String(this.y).replace(".", decimalSeparator) + '%';
                }
            },
            accessibility: {
                description: descriptionData
            },
            plotOptions: {
                series: {
                    animation: {
                        complete: function () {
                            $('#' + uniqueName + ' .highcharts-container svg')[0].setAttribute("viewBox", "-5 0 235 250");
                        }
                    }
                },
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    center: [100, 100],
                    dataLabels: {
                        enabled: false,
                        formatter: function () {
                            var pointName = this.point.name;
                            if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                            return '<b>' + pointName + '</b>:' + String(this.y).replace(".", decimalSeparator) + '%';
                        }
                    }
                }
            },
            series: [{ type: 'pie', data: masData }]
        });
    });
}


window.initLineHighchartWidget = function() {

    $(".line_chart_container_pie").each(function (i, val) {
        var html = val.ownerDocument.all;
        var descriptionData = "";
        if (html.item("maturityTitle") != null) {
            var titleElement = html.item("maturityTitle");
            var tickerElement = html.item("maturityTicker");
            var titleName = titleElement.innerText;
            titleName = "Bar Chart illustrating the average maturity";
            if (tickerElement!=null) {
                var tickerName = tickerElement.innerText;
                if (tickerName !== "" && tickerName !== " " && tickerName !== undefined) {
                    tickerName = "  of the " + tickerName + " portfolio.";
                    descriptionData = titleName + tickerName;
                }
                else {
                    descriptionData = titleName;
                }
            }
            else {
                descriptionData = titleName;
            }
        }
        var uniqueName = "line_chart" + i;
        $(val).attr("id", uniqueName);

        var masDataX = [];
        var masData = [];
        $(val).parent().find(".line_chart_data input").each(function (i2, val2) {
            masDataX.push($(val2).attr("name"));
            var value = $(val2).attr("value").replace(',', '.');
            var flo = parseFloat(value);
            if (flo >= 0.0) {
                masData.push(flo);
            }
        });
        if (masDataX.length === 0 || masData.length === 0) return;

        var xAxisTitle = {
            text: $(this).data("label")
        };
        var yAxisFormatterFunction = function () { return this.value + "%"; };
        var toolTipFormatterFunction = function () {
            return '<b>' + this.series.name + '</b><br/>' +
                this.x + ': ' + Highcharts.numberFormat(this.y, 1) + '%';
        };
        var seriesName = 'Years';

        if (typeof VanEckHighchartOptions !== "undefined") {
            if(VanEckHighchartOptions.decimalPoint) {
                Highcharts.setOptions({
                    lang: {decimalPoint: VanEckHighchartOptions.decimalPoint}
                });
            }

            if(VanEckHighchartOptions.labelText) {
                xAxisTitle.text = VanEckHighchartOptions.labelText;
                yAxisFormatterFunction = function () { return Highcharts.numberFormat(this.value, 1) + "%"; };
                toolTipFormatterFunction = function () {
                    return '<b>' + VanEckHighchartOptions.labelText + '</b><br/>' +
                        this.x + ': ' + Highcharts.numberFormat(this.y, 1) + '%';
                };
            }

            if(VanEckHighchartOptions.seriesText) {
                seriesName = VanEckHighchartOptions.seriesText;
            }
        }

        chart = new Highcharts.Chart({
            chart: {
                renderTo: uniqueName,
                type: 'column'
            },
            title: { text: null },
            xAxis: {
                title: xAxisTitle,
                categories: masDataX,
                labels: {
                    rotation: -40,
                    align: 'right',
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            },
            yAxis: {
                min: 0,
                tickPixelInterval: 25,
                title: { text: null },
                labels: {
                    formatter: yAxisFormatterFunction
                }
            },
            legend: { enabled: false },
            tooltip: {
                formatter: toolTipFormatterFunction
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            accessibility: {
                description: descriptionData
            },
            series: [{ name: seriesName, data: masData }],
            credits: { enabled: false }
        });
    });
}

function initBarHighchartWidget() {
    $(".bar_chart_container").each(function (i, chartContainer) {
        var uniqueName = "bar_chart" + i;
        var xAxesSpace = -10;
        $(chartContainer).attr("id", uniqueName);
        var decimalSeparator = $(chartContainer).data("decimal-separator") || ".";

        var masColor = [];
        $(chartContainer).parent().find(".details .dia_color").each(function () {
            masColor.push($(this).css("color"));
        });
        if (masColor.length === 0) return;

        var masData = [];
        $(chartContainer).parent().find(".details .data").each(function () {
            var col1 = $(this).find(".col1").text();
            var col2 = $(this).find(".col2").text().replace(',', '.');
            var flo = parseFloat(col2);
            if (flo != '') {
                masData.push([col1, flo]);
            }
            if (flo < 0.0001) {
                xAxesSpace = 10;
            }
        });
        if (masData.length === 0) return;

        Highcharts.setOptions({ colors: masColor });

        Highcharts.chart(uniqueName, {
            chart: {
                type: 'bar',
                height: (masData.length + 1) * 28,
            },
            credits: { enabled: false },
            title: { text: '' },
            legend: { enabled: false },
            yAxis: { visible: false, },

            xAxis: {
                type: 'category',
                lineWidth: 0,
                tickInterval: 1,
                labels: {
                    x: xAxesSpace,
                    reserveSpace: true,
                    style: {
                        fontSize: '12px',
                        fontFamily: 'Verdana, sans-serif',
                        lineHeight: 30,
                    }
                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        style: {
                            fontWeight: 'normal',
                            fontSize: '12px',
                            fontFamily: 'Verdana, sans-serif',
                            textOutline: 0
                        },
                    },
                }
            },
            tooltip: {
                formatter: function () {
                    var pointName = this.point.name;
                    if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                    return '<b>' + pointName + '</b>:' + String(this.y).replace(".", decimalSeparator) + '%';
                }
            },
            series: [{
                pointWidth: 20, // bar height
                data: masData,
                dataLabels: {
                    enabled: true,
                    align: 'left',
                    x: 20,
                    format: '{point.y:.1f}' // one decimal
                }
            }]
        });
    });
}

function initMaturityLineHighchartWidget() {
    $(".maturity_line_chart_container").each(function (i, chartContainer) {
        var uniqueName = "maturity_line_chart" + i;
        $(chartContainer).attr("id", uniqueName);
        var decimalSeparator = $(chartContainer).data("decimal-separator") || ".";

        var masColor = [];
        $(chartContainer).parent().find(".details .dia_color").each(function () {
            masColor.push($(this).css("color"));
        });
        if (masColor.length === 0) return;

        var masData = [];
        $(chartContainer).parent().find(".details .data").each(function () {
            var seriesName = $(this).find(".seriesName").text();
            var xAxis = $(this).find(".col1 > string").toArray();
            var yAxis = $(this).find(".col2 > number").toArray();

            if (yAxis.length !== xAxis.length) {
                return;
            }

            var seriesData = [];
            for (var j = 0; j < yAxis.length; j++) {
                var xValue = parseFloat($(xAxis[j]).text().replace(',', '.'));
                var yValue = parseFloat($(yAxis[j]).text().replace(',', '.'));

                seriesData.push(
                    [
                        xValue,
                        yValue
                    ]
                );
            }

            masData.push({
                name: seriesName,
                data: seriesData
            });
        });

        if (masData.length === 0) return;

        Highcharts.setOptions({ colors: masColor });

        Highcharts.chart(uniqueName, {
            chart: {
                type: 'line',
                height: 281,
                width: 520,
            },
            credits: { enabled: false },
            title: { text: '' },

            yAxis: {
                title: {
                    text: 'Yield (%)',
                    style: {
                        fontSize: '14px',
                    },
                },
                gridLineColor: '#ccd6eb',
                gridLineDashStyle: 'ShortDot',
                tickInterval: 1,
                min: 0
            },
            xAxis: {
                title: {
                    text: 'Maturity (Years)',
                    style: {
                        fontSize: '14px',
                    },
                },
                categories: [],
                tickInterval: 1,
            },
            plotOptions: {
                line: {
                    marker: { enabled: false },
                }
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 450
                        },
                        chartOptions: {
                            chart: {
                                width: 350,
                            }
                        }
                    }
                ]
            },
            tooltip: {
                formatter: function () {
                    var pointName = this.point.series.name;
                    if (pointName.length > 20) { pointName = pointName.substring(0, 20) + ".."; }
                    return pointName + '<br/>' + '<b>' + this.x + '</b>: ' + String(this.y).replace(".", decimalSeparator) + '%';
                }
            },
            series: masData
        });
    });
}

function getVerticalBannerAd(sUrl) {
    // TODO: VK - Remove the function when we find where this is invoked from.
}

$(function () {
    if ($('.bs3-tooltip [data-toggle="tooltip"]').length === 0) return;

    if ($(window).width() < 539) {
        $('.bs3-tooltip [data-toggle="tooltip"]').tooltip({
            placement: 'top',
            container: $('.bs3-tooltip:first')
        });
    }
    else {
        $('.bs3-tooltip [data-toggle="tooltip"]').tooltip({
            placement: 'right',
            trigger: 'hover',
            container: $('.bs3-tooltip:first')
        });
    }
});

$(function () {
    var $modalButtons = $(".modal-js");
    if ($modalButtons.length === 0) return;
    $modalButtons.each(function () {
        var $modalButton = $(this);
        var modalId = $modalButton.attr("class").match("id-[^\s]*");
        if (!modalId) return;
        $modalButton.click(function (e) {
            e.preventDefault();
            $("#" + modalId).modal("show");
        });
    });

    //Close Fund Page Banner
    $(".fund-banner-close-button").click(function () {
        $(".fund-banner-wrapper").hide();
    });
});

var customDropdown = {
    init: function (form, dropClass) {
        $(form).find(dropClass).each(function () {
            customDropdown.addDropdown($(this)); // Add dropdowns
            customDropdown.dropdownEventHandler($(this)); //Dropdown event handler
        });
    },
    dropdownEventHandler: function (dropWrap) {
        dropWrap.find(".dropdown-item").click(function () {
            customDropdown.changeSelector(dropWrap.find("select"), $(this).attr("value"));
            dropWrap.find(".dropdown__button span").text($(this).text());
            //dropWrap.find(".dropdown__button").attr("data-value", $(this).attr("value"));
        });
    },
    changeSelector: function (dropdown, selectedVal) {
        dropdown.find("option").removeAttr("selected");
        dropdown.find("option").each(function () {
            if ($(this).attr('value') == selectedVal) {
                $(this).attr("selected", "selected");
                dropdown.val(selectedVal)
            }
        });
    },
    addDropdown: function (dropWrap) {
        var _html = '';
        var selectElm = dropWrap.find("select");

        // IE fix
        selectElm.find('[data-f-default-value]').attr("selected", "selected");

        _html += '<button aria-haspopup="true" aria-expanded="false" data-value="' + selectElm.find("option:selected").val() + '" class="dropdown__button text-util-sm mb-3" data-toggle="dropdown" id="' + selectElm.attr('id') + '-select" type="button">';
        _html += '<span class="dropdown__label" >' + selectElm.find(":selected").text() + '</span >';
        _html += '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="chevron-down" class="svg-inline--fa fa-chevron-down fa-w-16 fa-2x dropdown__icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">';
        _html += '<path fill="currentColor" d="M2.26 4.88a.75.75 0 00-.54.21.75.75 0 000 1.07l6.75 6.75a.75.75 0 001.06 0l6.75-6.75a.75.75 0 000-1.07.75.75 0 00-1.06 0L9 11.31 2.78 5.1a.75.75 0 00-.52-.21z"></path>';
        _html += '</svg></button>';

        _html += '<div class="dropdown-menu dropdown__menu text-util-sm" role="menu">';

        selectElm.find("option").each(function () {
            _html += '<button class="dropdown-item dropdown__item text-util-sm" role="menuitem" type="button" value="' + $(this).val() + '">' + $(this).text() + '</button>';
        });

        _html += "</div>";

        selectElm.hide();
        dropWrap.append(_html);
    }
}

var detectwidth = {
    init: function (forms) {
        $(forms).each(function (i, e) {
            $(e).addClass("narrow-width-form");
        });
    }
}


function checkPerformancePastYearsHasData() {
    //Check if the block exists

    if ($("#hdnSeriesData").length == 0) return;

    //Get and parse the seriesItems
    const seriesData = JSON.parse($("#hdnSeriesData").val());

    //Check if all the series are null
    for (var i = 0; i < seriesData.length; i++) {
        for (var j = 0; j < seriesData[i].data.length; j++) {
            if (seriesData[i].data[j] !== null) {
                return;
            }
        }
    }

    //If so hide the block
    $("#hdnSeriesData").closest(".past-years-chart-block").hide();

}


window.addEventListener('load', function () {

    checkPerformancePastYearsHasData();

    customDropdown.init(".custom-select-form", ".dropdown");
    detectwidth.init('.manage-subscriptions-block, .new-subscription-block, .one-click-form, .manage-subscriptions-link');
    $(".bs4-subscribe.one-click-form .text-util-sm").text($(".bs4-subscribe.one-click-form").find(".subscribe-to__title").text());
    $(".bs4-subscribe.one-click-form .h3").text($(".bs4-subscribe.one-click-form").find(".subscribe-to").text());
    $(".bs4-subscribe.one-click-form").find(".subscribe-to__title, .subscribe-to").remove();
    //epiWidthObserver();
});